"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var sjcl_1 = __importDefault(require("sjcl"));
var urijs_1 = __importDefault(require("urijs"));
var Constants = __importStar(require("./Constants"));
var Helpers_1 = require("./Helpers");
var Crypto_1 = require("./Crypto");
var Crypto_2 = require("./Crypto");
exports.CryptoManager = Crypto_2.CryptoManager;
exports.AsymmetricCryptoManager = Crypto_2.AsymmetricCryptoManager;
exports.AsymmetricKeyPair = Crypto_2.AsymmetricKeyPair;
exports.deriveKey = Crypto_2.deriveKey;
exports.genUid = Crypto_2.genUid;
var Constants_1 = require("./Constants");
exports.CURRENT_VERSION = Constants_1.CURRENT_VERSION;
var ExtendableError = /** @class */ (function (_super) {
    __extends(ExtendableError, _super);
    function ExtendableError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ExtendableError.prototype);
        _this.name = 'ExtendableError';
        _this.stack = (new Error(message)).stack;
        return _this;
    }
    return ExtendableError;
}(Error));
var HTTPError = /** @class */ (function (_super) {
    __extends(HTTPError, _super);
    function HTTPError(status, message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, HTTPError.prototype);
        _this.name = 'HTTPError';
        _this.status = status;
        return _this;
    }
    return HTTPError;
}(ExtendableError));
exports.HTTPError = HTTPError;
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    function NetworkError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, NetworkError.prototype);
        _this.name = 'NetworkError';
        return _this;
    }
    return NetworkError;
}(ExtendableError));
exports.NetworkError = NetworkError;
var IntegrityError = /** @class */ (function (_super) {
    __extends(IntegrityError, _super);
    function IntegrityError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, IntegrityError.prototype);
        _this.name = 'IntegrityError';
        return _this;
    }
    return IntegrityError;
}(ExtendableError));
exports.IntegrityError = IntegrityError;
var EncryptionPasswordError = /** @class */ (function (_super) {
    __extends(EncryptionPasswordError, _super);
    function EncryptionPasswordError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, EncryptionPasswordError.prototype);
        _this.name = 'EncryptionPasswordError';
        return _this;
    }
    return EncryptionPasswordError;
}(ExtendableError));
exports.EncryptionPasswordError = EncryptionPasswordError;
// FIXME: Make secure + types
function CastJson(json, to) {
    return Object.assign(to, json);
}
function hmacToHex(hmac) {
    return sjcl_1.default.codec.hex.fromBits(sjcl_1.default.codec.bytes.toBits(hmac));
}
var Credentials = /** @class */ (function () {
    function Credentials(email, authToken) {
        this.email = email;
        this.authToken = authToken;
    }
    return Credentials;
}());
exports.Credentials = Credentials;
var CollectionInfo = /** @class */ (function () {
    function CollectionInfo(json) {
        CastJson(json, this);
    }
    return CollectionInfo;
}());
exports.CollectionInfo = CollectionInfo;
var BaseItem = /** @class */ (function () {
    function BaseItem() {
        this._json = {};
    }
    BaseItem.prototype.deserialize = function (json) {
        this._json = Object.assign({}, json);
        if (json.content) {
            this._encrypted = sjcl_1.default.codec.bytes.fromBits(sjcl_1.default.codec.base64.toBits(json.content));
        }
        this._content = undefined;
    };
    BaseItem.prototype.serialize = function () {
        return Object.assign({}, this._json, { content: sjcl_1.default.codec.base64.fromBits(sjcl_1.default.codec.bytes.toBits(this._encrypted)) });
    };
    BaseItem.prototype.verifyBase = function (hmac, calculated) {
        if (!this.hmacEqual(hmac, calculated)) {
            throw new IntegrityError('Bad HMAC. ' + hmacToHex(hmac) + ' != ' + hmacToHex(calculated));
        }
    };
    BaseItem.prototype.hmacEqual = function (hmac, calculated) {
        return (hmac.length === calculated.length) &&
            (hmac.every(function (v, i) { return v === calculated[i]; }));
    };
    return BaseItem;
}());
var BaseJournal = /** @class */ (function (_super) {
    __extends(BaseJournal, _super);
    function BaseJournal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BaseJournal.prototype, "uid", {
        get: function () {
            return this._json.uid;
        },
        enumerable: true,
        configurable: true
    });
    return BaseJournal;
}(BaseItem));
var Journal = /** @class */ (function (_super) {
    __extends(Journal, _super);
    function Journal(initial, version) {
        if (version === void 0) { version = Constants.CURRENT_VERSION; }
        var _this = _super.call(this) || this;
        _this.deserialize(__assign({ version: version }, initial));
        return _this;
    }
    Object.defineProperty(Journal.prototype, "key", {
        get: function () {
            if (this._json.key) {
                return sjcl_1.default.codec.bytes.fromBits(sjcl_1.default.codec.base64.toBits(this._json.key));
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Journal.prototype, "owner", {
        get: function () {
            return this._json.owner;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Journal.prototype, "readOnly", {
        get: function () {
            return this._json.readOnly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Journal.prototype, "lastUid", {
        get: function () {
            return this._json.lastUid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Journal.prototype, "version", {
        get: function () {
            return this._json.version;
        },
        enumerable: true,
        configurable: true
    });
    Journal.prototype.getCryptoManager = function (derived, keyPair) {
        if (this.key) {
            var asymmetricCryptoManager = new Crypto_1.AsymmetricCryptoManager(keyPair);
            var derivedJournalKey = asymmetricCryptoManager.decryptBytes(this.key);
            return Crypto_1.CryptoManager.fromDerivedKey(derivedJournalKey, this.version);
        }
        else {
            return new Crypto_1.CryptoManager(derived, this.uid, this.version);
        }
    };
    Journal.prototype.setInfo = function (cryptoManager, info) {
        this._json.uid = info.uid;
        this._content = info;
        var encrypted = cryptoManager.encrypt(JSON.stringify(this._content));
        this._encrypted = this.calculateHmac(cryptoManager, encrypted).concat(encrypted);
    };
    Journal.prototype.getInfo = function (cryptoManager) {
        this.verify(cryptoManager);
        if (this._content === undefined) {
            this._content = JSON.parse(cryptoManager.decrypt(this.encryptedContent()));
        }
        var ret = new CollectionInfo(this._content);
        ret.uid = this.uid;
        return ret;
    };
    Journal.prototype.calculateHmac = function (cryptoManager, encrypted) {
        var prefix = Helpers_1.stringToByteArray(this.uid);
        return cryptoManager.hmac(prefix.concat(encrypted));
    };
    Journal.prototype.verify = function (cryptoManager) {
        var calculated = this.calculateHmac(cryptoManager, this.encryptedContent());
        var hmac = this._encrypted.slice(0, Crypto_1.HMAC_SIZE_BYTES);
        _super.prototype.verifyBase.call(this, hmac, calculated);
    };
    Journal.prototype.encryptedContent = function () {
        return this._encrypted.slice(Crypto_1.HMAC_SIZE_BYTES);
    };
    return Journal;
}(BaseJournal));
exports.Journal = Journal;
var SyncEntryAction;
(function (SyncEntryAction) {
    SyncEntryAction["Add"] = "ADD";
    SyncEntryAction["Delete"] = "DELETE";
    SyncEntryAction["Change"] = "CHANGE";
})(SyncEntryAction = exports.SyncEntryAction || (exports.SyncEntryAction = {}));
var SyncEntry = /** @class */ (function () {
    function SyncEntry(json, uid) {
        CastJson(json, this);
        this.uid = uid;
    }
    return SyncEntry;
}());
exports.SyncEntry = SyncEntry;
var Entry = /** @class */ (function (_super) {
    __extends(Entry, _super);
    function Entry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Entry.prototype.setSyncEntry = function (cryptoManager, info, prevUid) {
        this._content = info;
        this._encrypted = cryptoManager.encrypt(JSON.stringify(this._content));
        this._json.uid = hmacToHex(this.calculateHmac(cryptoManager, this._encrypted, prevUid));
    };
    Entry.prototype.getSyncEntry = function (cryptoManager, prevUid) {
        this.verify(cryptoManager, prevUid);
        if (this._content === undefined) {
            this._content = JSON.parse(cryptoManager.decrypt(this._encrypted));
        }
        return new SyncEntry(this._content, this.uid);
    };
    Entry.prototype.verify = function (cryptoManager, prevUid) {
        var calculated = this.calculateHmac(cryptoManager, this._encrypted, prevUid);
        var hmac = sjcl_1.default.codec.bytes.fromBits(sjcl_1.default.codec.hex.toBits(this.uid));
        _super.prototype.verifyBase.call(this, hmac, calculated);
    };
    Entry.prototype.calculateHmac = function (cryptoManager, encrypted, prevUid) {
        var prefix = (prevUid !== null) ? Helpers_1.stringToByteArray(prevUid) : [];
        return cryptoManager.hmac(prefix.concat(encrypted));
    };
    return Entry;
}(BaseJournal));
exports.Entry = Entry;
var UserInfo = /** @class */ (function (_super) {
    __extends(UserInfo, _super);
    function UserInfo(owner, version) {
        if (version === void 0) { version = Constants.CURRENT_VERSION; }
        var _this = _super.call(this) || this;
        _this._json.version = version;
        _this._owner = owner;
        return _this;
    }
    Object.defineProperty(UserInfo.prototype, "version", {
        get: function () {
            return this._json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserInfo.prototype, "owner", {
        get: function () {
            return this._owner;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserInfo.prototype, "publicKey", {
        get: function () {
            return this._json.pubkey;
        },
        enumerable: true,
        configurable: true
    });
    UserInfo.prototype.serialize = function () {
        var ret = _super.prototype.serialize.call(this);
        ret.owner = this._owner;
        return ret;
    };
    UserInfo.prototype.getCryptoManager = function (derived) {
        return new Crypto_1.CryptoManager(derived, 'userInfo', this.version);
    };
    UserInfo.prototype.setKeyPair = function (cryptoManager, keyPair) {
        this._json.pubkey = sjcl_1.default.codec.base64.fromBits(sjcl_1.default.codec.bytes.toBits(keyPair.publicKey));
        this._content = keyPair.privateKey;
        var encrypted = cryptoManager.encryptBytes(keyPair.privateKey);
        this._encrypted = this.calculateHmac(cryptoManager, encrypted).concat(encrypted);
    };
    UserInfo.prototype.getKeyPair = function (cryptoManager) {
        this.verify(cryptoManager);
        if (this._content === undefined) {
            this._content = cryptoManager.decryptBytes(this.encryptedContent());
        }
        var pubkey = sjcl_1.default.codec.bytes.fromBits(sjcl_1.default.codec.base64.toBits(this._json.pubkey));
        return new Crypto_1.AsymmetricKeyPair(pubkey, this._content);
    };
    UserInfo.prototype.calculateHmac = function (cryptoManager, encrypted) {
        var postfix = sjcl_1.default.codec.bytes.fromBits(sjcl_1.default.codec.base64.toBits(this._json.pubkey));
        return cryptoManager.hmac(encrypted.concat(postfix));
    };
    UserInfo.prototype.verify = function (cryptoManager) {
        var calculated = this.calculateHmac(cryptoManager, this.encryptedContent());
        var hmac = this._encrypted.slice(0, Crypto_1.HMAC_SIZE_BYTES);
        _super.prototype.verifyBase.call(this, hmac, calculated);
    };
    UserInfo.prototype.encryptedContent = function () {
        return this._encrypted.slice(Crypto_1.HMAC_SIZE_BYTES);
    };
    return UserInfo;
}(BaseItem));
exports.UserInfo = UserInfo;
// FIXME: baseUrl and apiBase should be the right type all around.
var BaseNetwork = /** @class */ (function () {
    function BaseNetwork(apiBase) {
        this.apiBase = urijs_1.default(apiBase).normalize();
    }
    BaseNetwork.urlExtend = function (_baseUrl, segments) {
        var baseUrl = _baseUrl;
        baseUrl = baseUrl.clone();
        for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
            var segment = segments_1[_i];
            baseUrl.segment(segment);
        }
        return baseUrl.normalize();
    };
    BaseNetwork.prototype.newCall = function (segments, extra, _apiBase) {
        if (segments === void 0) { segments = []; }
        if (extra === void 0) { extra = {}; }
        if (_apiBase === void 0) { _apiBase = this.apiBase; }
        var apiBase = BaseNetwork.urlExtend(_apiBase, segments);
        extra = __assign(__assign({}, extra), { headers: __assign({ Accept: 'application/json' }, extra.headers) });
        return new Promise(function (resolve, reject) {
            fetch(apiBase.toString(), extra).then(function (response) {
                response.text().then(function (text) {
                    var json;
                    var body = text;
                    try {
                        json = JSON.parse(text);
                        body = json;
                    }
                    catch (e) {
                        body = text;
                    }
                    if (response.ok) {
                        resolve(body);
                    }
                    else {
                        if (json) {
                            reject(new HTTPError(response.status, json.detail || json.non_field_errors || JSON.stringify(json)));
                        }
                        else {
                            reject(new HTTPError(response.status, body));
                        }
                    }
                }).catch(function (error) {
                    reject(error);
                });
            }).catch(function (error) {
                reject(new NetworkError(error.message));
            });
        });
    };
    return BaseNetwork;
}());
var Authenticator = /** @class */ (function (_super) {
    __extends(Authenticator, _super);
    function Authenticator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Authenticator.prototype.getAuthToken = function (username, password) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // FIXME: should be FormData but doesn't work for whatever reason
            var form = 'username=' + encodeURIComponent(username) +
                '&password=' + encodeURIComponent(password);
            var extra = {
                method: 'post',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                body: form,
            };
            _this.newCall(['api-token-auth', ''], extra).then(function (json) {
                resolve(json.token);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    Authenticator.prototype.invalidateToken = function (authToken) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var extra = {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': 'Token ' + authToken,
                },
            };
            _this.newCall(['api', 'logout', ''], extra).then(function () {
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    return Authenticator;
}(BaseNetwork));
exports.Authenticator = Authenticator;
var BaseManager = /** @class */ (function (_super) {
    __extends(BaseManager, _super);
    function BaseManager(credentials, apiBase, segments) {
        var _this = _super.call(this, apiBase) || this;
        _this.credentials = credentials;
        _this.apiBase = BaseNetwork.urlExtend(_this.apiBase, ['api', 'v1'].concat(segments));
        return _this;
    }
    BaseManager.prototype.newCall = function (segments, extra, apiBase) {
        if (segments === void 0) { segments = []; }
        if (extra === void 0) { extra = {}; }
        if (apiBase === void 0) { apiBase = this.apiBase; }
        extra = __assign(__assign({}, extra), { headers: __assign({ 'Content-Type': 'application/json;charset=UTF-8', 'Authorization': 'Token ' + this.credentials.authToken }, extra.headers) });
        return _super.prototype.newCall.call(this, segments, extra, apiBase);
    };
    return BaseManager;
}(BaseNetwork));
exports.BaseManager = BaseManager;
var JournalManager = /** @class */ (function (_super) {
    __extends(JournalManager, _super);
    function JournalManager(credentials, apiBase) {
        return _super.call(this, credentials, apiBase, ['journals', '']) || this;
    }
    JournalManager.prototype.fetch = function (journalUid) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.newCall([journalUid, '']).then(function (json) {
                var journal = new Journal({ uid: json.uid }, json.version);
                journal.deserialize(json);
                resolve(journal);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    JournalManager.prototype.list = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.newCall().then(function (json) {
                resolve(json.map(function (val) {
                    var journal = new Journal({ uid: val.uid }, val.version);
                    journal.deserialize(val);
                    return journal;
                }));
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    JournalManager.prototype.create = function (journal) {
        var extra = {
            method: 'post',
            body: JSON.stringify(journal.serialize()),
        };
        return this.newCall([], extra);
    };
    JournalManager.prototype.update = function (journal) {
        var extra = {
            method: 'put',
            body: JSON.stringify(journal.serialize()),
        };
        return this.newCall([journal.uid, ''], extra);
    };
    JournalManager.prototype.delete = function (journal) {
        var extra = {
            method: 'delete',
        };
        return this.newCall([journal.uid, ''], extra);
    };
    return JournalManager;
}(BaseManager));
exports.JournalManager = JournalManager;
var EntryManager = /** @class */ (function (_super) {
    __extends(EntryManager, _super);
    function EntryManager(credentials, apiBase, journalId) {
        return _super.call(this, credentials, apiBase, ['journals', journalId, 'entries', '']) || this;
    }
    EntryManager.prototype.list = function (lastUid, limit) {
        var _this = this;
        if (limit === void 0) { limit = 0; }
        var apiBase = this.apiBase.clone();
        apiBase = apiBase.search({
            last: (lastUid !== null) ? lastUid : undefined,
            limit: (limit > 0) ? limit : undefined,
        });
        return new Promise(function (resolve, reject) {
            _this.newCall(undefined, undefined, apiBase).then(function (json) {
                resolve(json.map(function (val) {
                    var entry = new Entry();
                    entry.deserialize(val);
                    return entry;
                }));
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    EntryManager.prototype.create = function (entries, lastUid) {
        var apiBase = this.apiBase.clone();
        apiBase = apiBase.search({
            last: (lastUid !== null) ? lastUid : undefined,
        });
        var extra = {
            method: 'post',
            body: JSON.stringify(entries.map(function (x) { return x.serialize(); })),
        };
        return this.newCall(undefined, extra, apiBase);
    };
    return EntryManager;
}(BaseManager));
exports.EntryManager = EntryManager;
var JournalMembersManager = /** @class */ (function (_super) {
    __extends(JournalMembersManager, _super);
    function JournalMembersManager(credentials, apiBase, journalId) {
        return _super.call(this, credentials, apiBase, ['journals', journalId, 'members', '']) || this;
    }
    JournalMembersManager.prototype.list = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.newCall().then(function (json) {
                resolve(json.map(function (val) {
                    return val;
                }));
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    JournalMembersManager.prototype.create = function (journalMember) {
        var extra = {
            method: 'post',
            body: JSON.stringify(journalMember),
        };
        return this.newCall([], extra);
    };
    JournalMembersManager.prototype.delete = function (journalMember) {
        var extra = {
            method: 'delete',
        };
        return this.newCall([journalMember.user, ''], extra);
    };
    return JournalMembersManager;
}(BaseManager));
exports.JournalMembersManager = JournalMembersManager;
var UserInfoManager = /** @class */ (function (_super) {
    __extends(UserInfoManager, _super);
    function UserInfoManager(credentials, apiBase) {
        return _super.call(this, credentials, apiBase, ['user', '']) || this;
    }
    UserInfoManager.prototype.fetch = function (owner) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.newCall([owner, '']).then(function (json) {
                var userInfo = new UserInfo(owner, json.version);
                userInfo.deserialize(json);
                resolve(userInfo);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    UserInfoManager.prototype.create = function (userInfo) {
        var extra = {
            method: 'post',
            body: JSON.stringify(userInfo.serialize()),
        };
        return this.newCall([], extra);
    };
    UserInfoManager.prototype.update = function (userInfo) {
        var extra = {
            method: 'put',
            body: JSON.stringify(userInfo.serialize()),
        };
        return this.newCall([userInfo.owner, ''], extra);
    };
    UserInfoManager.prototype.delete = function (userInfo) {
        var extra = {
            method: 'delete',
        };
        return this.newCall([userInfo.owner, ''], extra);
    };
    return UserInfoManager;
}(BaseManager));
exports.UserInfoManager = UserInfoManager;
//# sourceMappingURL=EteSync.js.map